/* eslint-disable */

import React from 'react';

export default function WireframeTapBarMobile(props: { tabBarClassName: string }) {
    /**
     * Effect: Fix TapBar positioning on safari after burger menu was closed
     */
    const wasTapBarFixedRef = React.useRef(false);
    React.useEffect(() => {
        if (!window.C24M?.navi || wasTapBarFixedRef.current) {
            return;
        }

        const prevClosed = window.C24M.navi.closed;

        // eslint-disable-next-line fp/no-mutation
        window.C24M.navi.closed = () => {
            prevClosed();
            window.Check24?.hideTapBar();
            setTimeout(() => {
                window.Check24?.showTapBar();
            }, 400);
        };

        wasTapBarFixedRef.current = true;
    }, []);

    return (
        <>
            <style
                jsx
                global
            >{``}</style>
            <div className={`c24m-tap-bar ${props.tabBarClassName ?? ''}`}>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-start `}
                    href={`https://m.check24.de/`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M24.484,9.651L15.087,1.882c-.632-.51-1.549-.511-2.181.002L3.518,9.645c-.271.22-.427.544-.427.89l.002,15.094c0,.48.391.871.87.871h8.127v-7.85c0-.149.12-.27.27-.27h3.28c.149,0,.27.12.27.27v7.85h8.127c.479,0,.87-.391.87-.871l-.003-13.535.006-1.55c0-.35-.154-.676-.425-.894ZM23.087,24.68c-.051.051-.12.079-.191.079h-4.976c-.149,0-.27-.12-.27-.27v-6.98c0-.479-.391-.87-.87-.87h-5.562c-.479,0-.87.391-.87.87v6.98c0,.149-.12.27-.27.27h-4.976c-.149,0-.27-.12-.27-.27l-.003-13.176c0-.165.073-.32.202-.426L13.821,3.607c.1-.082.244-.082.344,0l8.796,7.284c.128.104.202.259.202.426l.002,13.172c0,.071-.028.141-.078.19Z"></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Start"
                    >
                        Start
                    </div>
                </a>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-activity `}
                    href={`https://m.check24.de/kundenbereich/?o=activitylist`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M21.822,26.5H6.178c-2.285,0-4.145-1.859-4.145-4.145V5.645C2.033,3.359,3.892,1.5,6.178,1.5h15.644c2.285,0,4.145,1.859,4.145,4.145v16.709c0,2.286-1.86,4.145-4.145,4.145ZM6.178,3.191c-1.354,0-2.455,1.101-2.455,2.455v16.709c0,1.354,1.101,2.455,2.455,2.455h15.644c1.354,0,2.455-1.101,2.455-2.455V5.645c0-1.354-1.101-2.455-2.455-2.455H6.178Z"></path>
                            <g>
                                <path d="M16.306,10.227H7.97c-.467,0-.845-.378-.845-.845s.378-.845.845-.845h8.336c.467,0,.845.378.845.845s-.378.845-.845.845Z"></path>
                                <path d="M13.963,14.845h-5.993c-.467,0-.845-.378-.845-.845s.378-.845.845-.845h5.993c.467,0,.845.378.845.845s-.378.845-.845.845Z"></path>
                                <path d="M12.592,19.464h-4.622c-.467,0-.845-.378-.845-.845s.378-.845.845-.845h4.622c.467,0,.845.378.845.845s-.378.845-.845.845Z"></path>
                            </g>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Aktivit&auml;ten"
                    >
                        Aktivit&auml;ten
                    </div>
                </a>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-wishlist `}
                    href={`https://m.check24.de/kundenbereich/?o=lists`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M20.158,1.5c-2.418,0-4.694,1.196-6.157,3.216-1.473-2.049-3.691-3.216-6.138-3.216C3.672,1.5.262,5.061.262,9.439c0,4.25,3.312,7.338,12.164,15.592l1.575,1.469,1.106-1.031c9.193-8.577,12.632-11.786,12.632-16.03,0-4.377-3.401-7.939-7.58-7.939ZM14.412,23.734l-.41.38-.804-.755C5.03,15.672,1.977,12.799,1.977,9.443c0-3.432,2.641-6.223,5.887-6.223,2.105,0,3.984,1.137,5.026,3.04.246.367.642.604,1.06.604.443,0,.887-.247,1.055-.588,1.271-1.991,3.09-3.056,5.153-3.056,3.246,0,5.887,2.803,5.887,6.249v.185c-.14,3.447-3.505,6.561-11.633,14.08Z"></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Merkzettel"
                    >
                        Merkzettel
                    </div>
                </a>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-overview `}
                    href={`https://m.check24.de/kundenbereich/?o=overview`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M14,14.485c3.58,0,6.493-2.912,6.493-6.492s-2.913-6.493-6.493-6.493-6.493,2.913-6.493,6.493,2.913,6.492,6.493,6.492ZM14,3.199c2.644,0,4.794,2.15,4.794,4.794s-2.15,4.793-4.794,4.793-4.794-2.15-4.794-4.793,2.15-4.794,4.794-4.794Z"></path>
                            <path d="M17.434,16.219h-6.867c-3.874,0-7.025,3.151-7.025,7.026v2.405c0,.47.38.85.85.85s.85-.38.85-.85v-2.405c0-2.938,2.39-5.327,5.326-5.327h6.867c2.937,0,5.326,2.39,5.326,5.327v2.405c0,.47.38.85.85.85s.85-.38.85-.85v-2.405c0-3.875-3.151-7.026-7.025-7.026Z"></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Profil"
                    >
                        Profil
                    </div>
                </a>
                <span
                    className={`c24m-tap-bar-option c24m-tap-bar-option-chat `}
                    data-qa-id="qa-tap-bar-option-chat"
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path
                                d="M16.772,8.984l1.278,4.309c.356,1.201,1.295,2.14,2.497,2.497l4.309,1.278c.452.134.452.774,0,.908l-4.309,1.278c-1.201.356-2.14,1.295-2.497,2.497l-1.278,4.309c-.134.452-.774.452-.908,0l-1.278-4.309c-.356-1.201-1.295-2.14-2.497-2.497l-4.309-1.278c-.452-.134-.452-.774,0-.908l4.309-1.278c1.201-.356,2.14-1.295,2.497-2.497l1.278-4.309c.134-.452.774-.452.908,0h0Z"
                                fill="#005c61"
                            ></path>
                            <path
                                d="M8.241,1.799l.744,2.511c.208.7.755,1.247,1.454,1.454l2.511.744c.263.078.263.451,0,.529l-2.511.744c-.7.208-1.247.755-1.454,1.454l-.744,2.511c-.078.263-.451.263-.529,0l-.744-2.511c-.208-.7-.755-1.247-1.454-1.454l-2.511-.744c-.263-.078-.263-.451,0-.529l2.511-.744c.7-.208,1.247-.755,1.454-1.454l.744-2.511c.078-.263.451-.263.529,0Z"
                                fill="#f07c00"
                            ></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Chat"
                    >
                        Chat
                    </div>
                </span>
            </div>
        </>
    );
}
